var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModeFav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Favorites"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_2850_48)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M63.4564 29.0267C61.8137 25.6805 59.1702 23.4269 55.5253 22.2661C52.0033 21.0489 48.5856 21.3177 45.2726 23.0719C42.7976 24.31 40.9899 25.8473 39.8391 27.6804C38.6884 25.8473 36.8801 24.31 34.4057 23.0719C31.0927 21.3177 27.675 21.0489 24.1524 22.2661C20.5075 23.4269 17.864 25.6805 16.2214 29.0267C14.5477 32.3035 14.2789 35.7213 15.4155 39.2799C16.2879 42.1742 19.2836 46.1369 24.4043 51.1691C27.6789 54.406 39.8138 64.825 39.816 64.8391C39.8239 64.8323 39.8313 64.8261 39.8391 64.8199C39.8465 64.8261 39.8538 64.8323 39.8617 64.8391C39.8639 64.825 39.8656 64.8097 39.8679 64.7957C46.8629 58.9486 51.9988 54.406 55.2734 51.1691C60.3942 46.1369 63.3904 42.1742 64.2622 39.2799C65.3988 35.7213 65.13 32.3035 63.4564 29.0267Z",
    fill: "#FF551D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shine",
    d: "M26.3614 26.8911V32.4914C23.4874 32.9929 21.1421 35.0272 20.2438 37.8003H19.7417C19.4616 36.955 19.3247 36.0838 19.3247 35.1906C19.3247 31.0702 22.2669 27.5831 26.3191 26.8962C26.3298 26.8911 26.3456 26.8911 26.3614 26.8911Z",
    fill: "#FFD8CB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2850_48",
    x1: 56.2963,
    y1: -5.59253e-7,
    x2: 20,
    y2: 81.8518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D3B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeFav);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;